export const scanningSubjectFormikConstants = {
  name: "name",
};

export const scanningSubjectInitialValues = (values) => ({
  [scanningSubjectFormikConstants.name]: values?.name || "",
});
